import { accessConfigGetSunpayAccessKeys } from '@sunwisesoftware/client-aftersales-js';

import * as creditFileSelectors from '../../creditFile/selectors';
import {
    FETCH_CREDENTIALS,
    FETCH_CREDENTIALS_FAILURE,
    FETCH_CREDENTIALS_SUCCESS,
} from '../actionTypes';
import { credentialIntegrationsActions } from '../reducer';

export default () => (dispatch, getState) => {
    const companyId = creditFileSelectors.getCreditInstallerId(getState());
    dispatch(credentialIntegrationsActions[FETCH_CREDENTIALS]());

    accessConfigGetSunpayAccessKeys({ query: { company_id: companyId } })
        .then((response) => {
            dispatch(
                credentialIntegrationsActions[FETCH_CREDENTIALS_SUCCESS](
                    response?.data,
                ),
            );
        })
        .catch((error) => {
            dispatch(
                credentialIntegrationsActions[FETCH_CREDENTIALS_FAILURE](
                    error?.response?.data?.detail,
                ),
            );
        });
};
